import Button, { ButtonProps } from 'components/src/input/Button'
import * as React from 'react'

const NewsletterSubmit = (props: ButtonProps) => (
    <Button {...props} type="submit" variant="primary" />
)

export default NewsletterSubmit
